import { useContext } from 'react';
import InitialRenderContext from '@/contexts/initial-render';

const useInitialRender = () => {
  const value = useContext(InitialRenderContext);

  return value;
};

export default useInitialRender;